// src/App.js
import React, { useEffect } from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';

// Socket-Client importieren
import socket from './socket';
import safeStorage from './utils/safeStorage';

// Deine Komponenten importieren
import Login from './components/Login';
import ShowPage from './components/ShowPage';
import Dashboard from './components/Dashboard';
import HomeView from './components/HomeView';
import FragenView from './components/QuestionsView';
import ManagementView from './components/ManagementView';
import MatrixEditor from './components/MatrixEditor';
import FinaleView from './components/FinaleView';
import ShowsView from './components/ShowsView';
import ShowEditView from './components/ShowEditView';
import OptionsView from './components/OptionsView';

const router = createBrowserRouter([
    {
        path: '/',
        element: <Login />,
    },
    {
        path: '/show',
        element: <ShowPage />,
    },
    {
        path: '/dashboard',
        element: <Dashboard />,
        children: [
            { index: true, element: <Navigate to="home" replace /> },
            { path: 'home', element: <HomeView /> },
            { path: 'fragen', element: <FragenView /> },
            { path: 'spielermanagement', element: <ManagementView /> },
            { path: 'matrix', element: <MatrixEditor /> },
            { path: 'finale-decoder', element: <FinaleView /> },
            { path: 'shows', element: <ShowsView /> },
            { path: 'shows/:id', element: <ShowEditView /> },
            { path: 'optionen', element: <OptionsView /> },
            // Legacy-Tabs (Pre-Refactor) leiten auf neue Struktur um
            { path: 'shows/:id/fragen', element: <ShowEditView /> },
            { path: 'shows/:id/matrix', element: <Navigate to="/dashboard/matrix" replace /> },
            { path: 'shows/:id/finale', element: <Navigate to="/dashboard/finale-decoder" replace /> },
        ],
    },
]);

function App() {
    useEffect(() => {
        const storedPlayerId = safeStorage.getItem('playerId');
        const storedTeamId = safeStorage.getItem('teamId');

        if (storedPlayerId) {
            console.log('[App] Rejoin mit playerId:', storedPlayerId);
            socket.emit('playerRejoin', { playerId: storedPlayerId });
        }
        if (storedTeamId) {
            console.log('[App] teamId bekannt:', storedTeamId);
        }
    }, []);

    return <RouterProvider router={router} />;
}

export default App;
